import { useState } from "react";
import { exportBriefContract } from "../contract";
import { Campaign, CampaignBrief, ContractTemplate } from "@types";

import useAuth from "@hooks/useAuth";
import LoadingSpinner from "@components/LoadingSpinner";
import FDropdown from "@components/FDropdown";

const EXPORT_OPTIONS = [
  { label: "Export to PDF", value: "exportToPdf" },
  { label: "Export to Docx", value: "exportToDocx" },
];

interface ExportContractDropdownProps {
  campaign: Campaign;
  brief: CampaignBrief;
  contractTemplate: ContractTemplate;
}

const ExportContractDropdown = ({
  campaign,
  brief,
  contractTemplate,
}: ExportContractDropdownProps) => {
  const { user } = useAuth();

  const [exportingContract, setExportingContract] = useState(false);

  const handleExportContract = async (format: "pdf" | "docx") => {
    setExportingContract(true);

    await exportBriefContract(campaign, brief, user, contractTemplate, format);

    setExportingContract(false);
  };

  return (
    <div className="absolute right-0 top-0">
      {exportingContract ? (
        <LoadingSpinner />
      ) : (
        <FDropdown
          width="auto"
          height="100%"
          className="pl-4"
          options={EXPORT_OPTIONS}
          onChange={(event) => {
            if (event === "exportToPdf") {
              handleExportContract("pdf");
            } else if (event === "exportToDocx") {
              handleExportContract("docx");
            }
          }}
          iconOnly={true}
          iconColor="#000F45"
          icon="ellipsis"
        />
      )}
    </div>
  );
};

export default ExportContractDropdown;
